import React from 'react';
import {
  IDictionaryNamedCohortFieldsFragment,
  ScheduleType,
} from '../../../utils/apollo/graphqlSchema';
import { useAppSelector } from '../../../redux/hooks';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import { ModalSliceType } from '../../../redux/slices/modal';
import Scheduler from '../../../components/Scheduler';

interface IProps {
  cohortId: string;
  cohortVersion: IDictionaryNamedCohortFieldsFragment['version'];
}

/**
 * This component is used to display opened scheduler modal for a cohort in Dictionary.
 * Because of the special props of <Scheduler>, we cannot use it directly out of
 * cohorts.map, therefore we need this component to wrap it.
 */
const CohortSchedulerContainer = ({ cohortId, cohortVersion }: IProps) => {
  const isCohortSchedulerOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.CreateSchedule, cohortId),
  );
  return isCohortSchedulerOpen && cohortVersion ? (
    <Scheduler
      entityId={cohortId}
      jobType={ScheduleType.BrazeCohortImport}
      prefilledName={cohortVersion.name}
      ignoreModalData={true}
    />
  ) : (
    <></>
  );
};

export default CohortSchedulerContainer;
